/**
 * App.js
 *
 * Description: The main parent component for the whole application.
 * Author: Parsa Badri
 * Date: 26/03/2024
 */

// Stylesheets start
import "./Assets/Styles/_app.scss";
import "./Assets/Styles/Auth.scss";
import "./Assets/Styles/Home.scss";
import "./Assets/Styles/Profile.scss";
import "./Assets/Styles/Select.scss";
import "./Assets/Styles/feather.css";
import "./Assets/Styles/TableFilter.scss";
import "./Assets/Styles/PaginationRowSelector.scss";
import "./Assets/Styles/AdminPanel.scss";
import "./Assets/Styles/AddWedding.scss";
// Stylesheets end
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import Login from "./Routes/Login";
import ResetPassword from "./Routes/ResetPassword";
import Signup from "./Routes/Signup";
import Home from "./Routes/Home/Home";
import { useEffect, useState } from "react";
import ResetPasswordToken from "./Routes/ResetPasswordToken";
import PasswordResetRequired from "./Routes/PasswordResetRequired";
import ActivateAccount from "./Routes/ActivateAccount";
import axios from "axios";
import useMediaQuery from "@mui/material/useMediaQuery";
import MobileView from "./Routes/MobileView";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import Landing from "./Routes/Landing";
import { GoogleOAuthProvider } from "@react-oauth/google";
import GoogleAuth from "./Routes/GoogleAuth";

function App() {
  const [NewRegisterAllowed, setNewRegisterAllowed] = useState(true);
  const isMobile = useMediaQuery("(max-width: 1200px)");

  useEffect(() => {
    // Setting the baseURL variable as a localStorage item for making API calls.
    // Deployed environments (qa/app/app-new/etc.) proxy /api on their own origin,
    // so use that origin directly instead of an allowlist that goes stale whenever
    // a new domain is stood up. Only local dev has no backend of its own.
    const origin = window.location.origin;
    if (origin.startsWith("http://localhost")) {
      window.localStorage.setItem("BaseURL", "https://dev.weddingly.io");
    } else {
      window.localStorage.setItem("BaseURL", origin);
    }
    fetchSettings();
  }, []);

  const fetchSettings = () => {
    let Req = {
      method: "GET",
      baseURL:
        window.localStorage.getItem("BaseURL") +
        "/api/system-settings/registration-allowed",
    };
    axios(Req)
      .then((Res) => {
        setNewRegisterAllowed(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  if (isMobile) {
    return <MobileView />;
  }

  return (
    <GoogleOAuthProvider clientId="815262930872-9h0khuo82dqui5gfn7i9ifu9t1oq4hq9.apps.googleusercontent.com">
      <ThemeProvider theme={theme}>
        <Router>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route
              path="/Login"
              element={<Login NewRegisterAllowed={NewRegisterAllowed} />}
            />
            <Route path="/Activate/:token" element={<ActivateAccount />} />
            <Route path="/Signup" element={<Signup />} />
            <Route
              path="/ResetPassword"
              element={
                <ResetPassword NewRegisterAllowed={NewRegisterAllowed} />
              }
            />
            <Route
              path="/ResetPassword/:token"
              element={<ResetPasswordToken />}
            />
            <Route
              path="/PasswordResetRequired"
              element={<PasswordResetRequired />}
            />
            <Route path="/Home/*" element={<Home />} />
            <Route path="/google-auth" element={<GoogleAuth />} />
            <Route path="*" element={<Navigate to="/Home" replace />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
